// Import all image files
import MTA_AmiahMims from "./images/MTA_AmiahMims/MTA_AmiahMims.png";
import MTA_AshleyNora from "./images/MTA_AshleyNora/MTA_AshleyNora.png";
import MTA_DeonnaCraig from "./images/MTA_DeonnaCraig/MTA_DeonnaCraig.png";
import MTA_DrJarrodDortch from "./images/MTA_DrJarrodDortch/MTA_DrJarrodDortch.png";
import MTA_EssMcKee from "./images/MTA_EssMcKee/MTA_EssMcKee.png";
import MTA_FINGERCREATIONS from "./images/MTA_FINGERCREATIONS/MTA_FINGERCREATIONS.png";
import MTA_FITZ from "./images/MTA_FITZ/MTA_FITZ.png";
import MTA_GaryGee from "./images/MTA_GaryGee/MTA_GaryGee.png";
import MTA_HarrietWatson from "./images/MTA_HarrietWatson/MTA_HarrietWatson.png";
import MTA_IsraelSolomon from "./images/MTA_IsraelSolomon/MTA_IsraelSolomon.png";
import MTA_JohnGMoore from "./images/MTA_JohnGMoore/MTA_JohnGMoore.png";
import MTA_KevinWest from "./images/MTA_KevinWest/MTA_KevinWest.png";
import MTA_KyngNathaniel from "./images/MTA_KyngNathaniel/MTA_KyngNathaniel.png";
import MTA_PopeGaskine from "./images/MTA_PopeGaskine/MTA_PopeGaskine.png";
import MTA_RaeParker from "./images/MTA_RaeParker/MTA_RaeParker.png";
import MTA_RebeccaRobinson from "./images/MTA_RebeccaRobinson/MTA_RebeccaRobinson.png";
import MTA_ShamiraWilson from "./images/MTA_ShamiraWilson/MTA_ShamiraWilson.png";
import MTA_WavyBlayne from "./images/MTA_WavyBlayne/MTA_WavyBlayne.png";

import MTA_AmiahMims_Full from "./images/MTA_AmiahMims/MTA_AmiahMims@2x.png";
import MTA_KevinWest_Full from "./images/MTA_KevinWest/MTA_KevinWest@2x.png";
import MTA_RebeccaRobinson_Full from "./images/MTA_RebeccaRobinson/MTA_RebeccaRobinson@2x.png";
import MTA_RaeParker_Full from "./images/MTA_RaeParker/MTA_RaeParker@2x.png";
import MTA_DrJarrodDortch_Full from "./images/MTA_DrJarrodDortch/MTA_DrJarrodDortch@2x.png";
import MTA_JohnGMoore_Full from "./images/MTA_JohnGMoore/MTA_JohnGMoore@2x.png";
import MTA_KyngNathaniel_Full from "./images/MTA_KyngNathaniel/MTA_KyngNathaniel@2x.png";
import MTA_EssMcKee_Full from "./images/MTA_EssMcKee/MTA_EssMcKee@2x.png";
import MTA_FINGERCREATIONS_Full from "./images/MTA_FINGERCREATIONS/MTA_FINGERCREATIONS@2x.png";
import MTA_WavyBlayne_Full from "./images/MTA_WavyBlayne/MTA_WavyBlayne@2x.png";
import MTA_GaryGee_Full from "./images/MTA_GaryGee/MTA_GaryGee@2x.png";
import MTA_HarrietWatson_Full from "./images/MTA_HarrietWatson/MTA_HarrietWatson@2x.png";
import MTA_FITZ_Full from "./images/MTA_FITZ/MTA_FITZ@2x.png";
import MTA_AshleyNora_Full from "./images/MTA_AshleyNora/MTA_AshleyNora@2x.png";
import MTA_ShamiraWilson_Full from "./images/MTA_ShamiraWilson/MTA_ShamiraWilson@2x.png";
import MTA_IsraelSolomon_Full from "./images/MTA_IsraelSolomon/MTA_IsraelSolomon@2x.png";
import MTA_DeonnaCraig_Full from "./images/MTA_DeonnaCraig/MTA_DeonnaCraig@2x.png";
import MTA_PopeGaskine_Full from "./images/MTA_PopeGaskine/MTA_PopeGaskine@2x.png";

import MTA_AmiahMims_Mobile from "./images/MTA_AmiahMims/MTA_AmiahMims_mobile.jpg";
import MTA_AshleyNora_Mobile from "./images/MTA_AshleyNora/MTA_AshleyNora_mobile.jpg";
import MTA_DeonnaCraig_Mobile from "./images/MTA_DeonnaCraig/MTA_DeonnaCraig_mobile.jpg";
import MTA_DrJarrodDortch_Mobile from "./images/MTA_DrJarrodDortch/MTA_DrJarrodDortch_mobile.jpg";
import MTA_EssMcKee_Mobile from "./images/MTA_EssMcKee/MTA_EssMcKee_mobile.jpg";
import MTA_FINGERCREATIONS_Mobile from "./images/MTA_FINGERCREATIONS/MTA_KennethHordge_mobile.jpg";
import MTA_FITZ_Mobile from "./images/MTA_FITZ/MTA_FITZ_mobile.jpg";
import MTA_GaryGee_Mobile from "./images/MTA_GaryGee/MTA_GaryGee_mobile.jpg";
import MTA_HarrietWatson_Mobile from "./images/MTA_HarrietWatson/MTA_HarrietWatson_mobile.jpg";
import MTA_IsraelSolomon_Mobile from "./images/MTA_IsraelSolomon/MTA_IsraelSolomon_mobile.jpg";
import MTA_JohnGMoore_Mobile from "./images/MTA_JohnGMoore/MTA_JohnGMoore_mobile.jpg";
import MTA_KevinWest_Mobile from "./images/MTA_KevinWest/MTA_KevinWest_mobile.jpg";
import MTA_KyngNathaniel_Mobile from "./images/MTA_KyngNathaniel/MTA_KyngRhodes_mobile.jpg";
import MTA_PopeGaskine_Mobile from "./images/MTA_PopeGaskine/MTA_PopeGaskine_mobile.jpg";
import MTA_RaeParker_Mobile from "./images/MTA_RaeParker/MTA_RaeParker_mobile.jpg";
import MTA_RebeccaRobinson_Mobile from "./images/MTA_RebeccaRobinson/MTA_RebeccaRobinson_mobile.jpg";
import MTA_ShamiraWilson_Mobile from "./images/MTA_ShamiraWilson/MTA_ShamiraWilson_mobile.jpg";
import MTA_WavyBlayne_Mobile from "./images/MTA_WavyBlayne/MTA_WavyBlayne_mobile.jpg";

import WTC_AshleyNora_720 from "./videos/WTC Ashley Nora 720 vF.mp4";
import WTC_HarrietWatson_720 from "./videos/WTC Harriet Watson 720 vF.mp4";
import WTC_AmiahMims_720 from "./videos/WTC Amiah Mims 720 vF.mp4";
import WTC_DeonnaCraig_720 from "./videos/WTC Deonna Craig 720 vF.mp4";
import WTC_DrJarrodDortch_720 from "./videos/WTC Dr Jarrod Dortch 720 vF.mp4";
import WTC_EssMcKee_720 from "./videos/WTC ess mckee 720 vF.mp4";
import WTC_Fitz_720 from "./videos/WTC Fitz 720 vF.mp4";
import WTC_GaryGee_720 from "./videos/WTC Gary Gee 720 vF.mp4";
import WTC_IsraelSolomon_720 from "./videos/WTC Israel Solomon 720 vF.mp4";
import WTC_JohnMoore_720 from "./videos/WTC John Moore 720 vF.mp4";
import WTC_KennethHordge_720 from "./videos/WTC Kenneth Hordge 720 vF.mp4";
import WTC_KevinWest_720 from "./videos/WTC Kevin West 720 vF.mp4";
import WTC_KyngRhodes_720 from "./videos/WTC Kyng Rhodes 720 vF.mp4";
import WTC_PopeGaskine_720 from "./videos/WTC Pope Gaskine 720 vF.mp4";
import WTC_RaeParker_720 from "./videos/WTC Rae Parker 720 vF.mp4";
import WTC_RebeccaRobinson_720 from "./videos/WTC Rebecca Robinson 720 vF.mp4";
import WTC_ShamiraWilson_720 from "./videos/WTC Shamira Wilson 720 vF.mp4";
import WTC_WavyBlayne_720 from "./videos/WTC Wavy Blayne 720 vF.mp4";

export function getArtistProfileData() {
    return {
        AmiahMimsyMims: {
            imageSortOrder: 1,
            sliderSortOrder: 1,
            mtaImage: MTA_AmiahMims,
            fullImage: MTA_AmiahMims_Full,
            mobileImage: MTA_AmiahMims_Mobile,
            name: 'Amiah "Mimsy" Mims',
            quote: "\"I do what I do because I don't really have a choice, I guess...it's something that's in me. It's a talent that I have. I like to deem my artistic ability as my superpower. Everybody has their own superpower and mine just happens to be in this creative field and I do it because it would be wasteful not to do it\"",
            videos: {
                mobile: WTC_AmiahMims_720
            }
        },
        KevinWest: {
            imageSortOrder: 2,
            sliderSortOrder: 17,
            mtaImage: MTA_KevinWest,
            fullImage: MTA_KevinWest_Full,
            mobileImage: MTA_KevinWest_Mobile,
            name: "Kevin West",
            quote: "\"One thing I’ve always had is faith. And I knew that God blessed me with a gift and if I just continued to work my gift and continued to create that he’ll eventually open up a door for me and there would be overflow.\"",
            videos: {
                mobile: WTC_KevinWest_720
            }
        },
        RebeccaRobinson: {
            imageSortOrder: 3,
            sliderSortOrder: 12,
            mtaImage: MTA_RebeccaRobinson,
            fullImage: MTA_RebeccaRobinson_Full,
            mobileImage: MTA_RebeccaRobinson_Mobile,
            name: "Rebecca Robinson",
            quote: "\"I've gone through some things over the years, and some very hurtful things, and I was tired of being seen as like I didn't have anything important to say just because I painted in color or painted really light topics. Or people might have seen my work and said, ‘Oh, it's beautiful,’ but it wasn't enough for me. I felt like I had something important to say.\"",
            videos: {
                mobile: WTC_RebeccaRobinson_720
            }
        },
        RaeParker: {
            imageSortOrder: 4,
            sliderSortOrder: 9,
            mtaImage: MTA_RaeParker,
            fullImage: MTA_RaeParker_Full,
            mobileImage: MTA_RaeParker_Mobile,
            name: "Rae Parker",
            quote: "\"I always tell [my students] to not give up on themselves. Keep pushing yourself, keep challenging yourself. A student will say, ‘I can't draw.’ If you can draw a dot, or if you can draw a line, then you can draw.\"",
            videos: {
                mobile: WTC_RaeParker_720
            }
        },
        DrJarrodNicholasDortch: {
            imageSortOrder: 5,
            sliderSortOrder: 8,
            mtaImage: MTA_DrJarrodDortch,
            fullImage: MTA_DrJarrodDortch_Full,
            mobileImage: MTA_DrJarrodDortch_Mobile,
            name: "Dr. Jarrod Nicholas Dortch",
            quote: "\"I grew up in [an] art-filled home and then I got involved in the arts because it was something that I really enjoyed during school. And then I found that when I was in college, when I was elsewhere, it just came to me a lot. I was drawn to it, so I started going to more art-related things. And then, once I was grown and living in Indianapolis, I got into some community art projects, and from there just kept moving forward.\"",
            videos: {
                mobile: WTC_DrJarrodDortch_720
            }
        },
        JohnGMooreJr: {
            imageSortOrder: 6,
            sliderSortOrder: 11,
            mtaImage: MTA_JohnGMoore,
            fullImage: MTA_JohnGMoore_Full,
            mobileImage: MTA_JohnGMoore_Mobile,
            name: "John G. Moore, Jr.",
            quote: "\"I like to use imagery and iconography that people see every day but put a different spin on it and make it have a different meaning.… I want my work to always be familiar enough that it opens people up to new ways of thinking about a particular subject or an object…but I don’t want to do work that pushes people away.\"",
            videos: {
                mobile: WTC_JohnMoore_720
            }
        },
        KyngRhodes: {
            imageSortOrder: 7,
            sliderSortOrder: 3,
            mtaImage: MTA_KyngNathaniel,
            fullImage: MTA_KyngNathaniel_Full,
            mobileImage: MTA_KyngNathaniel_Mobile,
            name: "Kyng Rhodes",
            quote: "\"It's a way to cope. It's a way to exercise my brain. It's a way to think through problems. And it's a gift to be able to create, to bring something into the world that didn't exist before.\"",
            videos: {
                mobile: WTC_KyngRhodes_720
            }
        },
        DeonnaCraig: {
            imageSortOrder: 8,
            sliderSortOrder: 7,
            mtaImage: MTA_DeonnaCraig,
            fullImage: MTA_DeonnaCraig_Full,
            mobileImage: MTA_DeonnaCraig_Mobile,
            name: "Deonna Craig",
            quote: "\"Art saved me. Art allowed me to find myself. Art allowed me to find the beauty in life and in others. And once I found that feeling, I never wanted to let it go.\"",
            videos: {
                mobile: WTC_DeonnaCraig_720
            }
        },
        IsraelSolomon: {
            imageSortOrder: 9,
            sliderSortOrder: 5,
            mtaImage: MTA_IsraelSolomon,
            fullImage: MTA_IsraelSolomon_Full,
            mobileImage: MTA_IsraelSolomon_Mobile,
            name: "Israel Solomon",
            quote: "\"One of the things that I want to do with my work is I want to make it personal to me. I want to create things that I can relate to and I’ve had experiences with. And it allows me to tell a story through my work.\"",
            videos: {
                mobile: WTC_IsraelSolomon_720
            }
        },
        essmckee: {
            imageSortOrder: 10,
            sliderSortOrder: 10,
            mtaImage: MTA_EssMcKee,
            fullImage: MTA_EssMcKee_Full,
            mobileImage: MTA_EssMcKee_Mobile,
            name: "ess mckee",
            quote: "\"I've been slightly political in my work at times. But I think a huge difference is that people automatically see me as an art activist, which I am. But it's not all that I create.\"",
            videos: {
                mobile: WTC_EssMcKee_720
            }
        },
        KennethHordge: {
            imageSortOrder: 11,
            sliderSortOrder: 14,
            mtaImage: MTA_FINGERCREATIONS,
            fullImage: MTA_FINGERCREATIONS_Full,
            mobileImage: MTA_FINGERCREATIONS_Mobile,
            name: "Kenneth Hordge (FINGERCREATIONS)",
            quote: "\"Black excellence is everywhere. It's in abundance, and I always wanted to show that through my work.\"",
            videos: {
                mobile: WTC_KennethHordge_720
            }
        },
        WavyBlayneMcCrary: {
            imageSortOrder: 12,
            sliderSortOrder: 18,
            mtaImage: MTA_WavyBlayne,
            fullImage: MTA_WavyBlayne_Full,
            mobileImage: MTA_WavyBlayne_Mobile,
            name: '"Wavy" Blayne McCrary',
            quote: "\"Why do I do what I do? I don't know. I have no other way to release and to feel fulfilled. I don't know. I want to be seen, I want to be heard. I want people to feel how I feel.\"",
            videos: {
                mobile: WTC_WavyBlayne_720
            }
        },
        GaryGee: {
            imageSortOrder: 13,
            sliderSortOrder: 16,
            mtaImage: MTA_GaryGee,
            fullImage: MTA_GaryGee_Full,
            mobileImage: MTA_GaryGee_Mobile,
            name: "Gary Gee",
            quote: "\"The piece was broken by firing and I put it back together. And I feel like my life had been broken and put back together.… Ceramics look hard in exterior, but they're fragile. Kind of like the human mind or the human spirit at times…. This broken piece got the most press and traveled with me to more places and opened more doors for me for any art show possible…. I'm thinking about it now, this piece represents me more than anything in life.\"",
            videos: {
                mobile: WTC_GaryGee_720
            }
        },
        HarrietWatson: {
            imageSortOrder: 14,
            sliderSortOrder: 2,
            mtaImage: MTA_HarrietWatson,
            fullImage: MTA_HarrietWatson_Full,
            mobileImage: MTA_HarrietWatson_Mobile,
            name: "Harriet Watson",
            quote: "\"My art has really taken from my history and how I've grown up in Indiana. Being a minority, being in a rural community, usually being the only Black person in the room growing up. So, a lot of my art is about how I feel like I've been perceived.\"",
            videos: {
                mobile: WTC_HarrietWatson_720
            }
        },
        FITZ: {
            imageSortOrder: 15,
            sliderSortOrder: 13,
            mtaImage: MTA_FITZ,
            fullImage: MTA_FITZ_Full,
            mobileImage: MTA_FITZ_Mobile,
            name: "FITZ",
            quote: "\"I do what I do not only to tell my story but to kind of like connect with people in ways that I've never been able to with words. My art is able to speak for me and do the things that I want to do while I'm here.\"",
            videos: {
                mobile: WTC_Fitz_720
            }
        },
        AshleyNora: {
            imageSortOrder: 16,
            sliderSortOrder: 4,
            mtaImage: MTA_AshleyNora,
            fullImage: MTA_AshleyNora_Full,
            mobileImage: MTA_AshleyNora_Mobile,
            name: "Ashley Nora",
            quote: "\"I found my voice, I found my style, I found what I wanted to say and how I want to say it. It sparked, it inspired me.\"",
            videos: {
                mobile: WTC_AshleyNora_720
            }
        },
        ShamiraWilson: {
            imageSortOrder: 17,
            sliderSortOrder: 15,
            mtaImage: MTA_ShamiraWilson,
            fullImage: MTA_ShamiraWilson_Full,
            mobileImage: MTA_ShamiraWilson_Mobile,
            name: "Shamira Wilson",
            quote: "\"I do what I do because it brings me joy. I just love creating and I feel like we are here to express ourselves.\"",
            videos: {
                mobile: WTC_ShamiraWilson_720
            }
        },
        PopeGaskine: {
            imageSortOrder: 18,
            sliderSortOrder: 6,
            mtaImage: MTA_PopeGaskine,
            fullImage: MTA_PopeGaskine_Full,
            mobileImage: MTA_PopeGaskine_Mobile,
            name: "Pope Gaskine",
            quote: "\"Art and music share a similar dynamic. They both are intangible. They come from an unknown source, an unknown force, and we're just bringing it to light, bringing strokes to life.\"",
            videos: {
                mobile: WTC_PopeGaskine_720
            }
        },
    };
}
